export default __webpack_public_path__ + "static/media/dive_shot3.59d0a671.png";